module.exports = __webpack_public_path__ + "img/kyIcon_3.f03e4f89.png";